import { render, staticRenderFns } from "./vantDialog.vue?vue&type=template&id=0245570b&"
import script from "./vantDialog.vue?vue&type=script&lang=js&"
export * from "./vantDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports